export default {
  documentLink: undefined,
  documentLinks: [],
};
